// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"10ed559e","205":"d9156a07","283":"885a63c9"}[chunkId] + ".chunk.css";
};